import { resolveFofocaStoryMedia } from '@/lib/layouts/resolveFofocaStoryMedia';
import type { PostLayoutConfig } from '@/lib/layouts/types';

/** Local compressed filler reel for template cards and the template editor
 *  preview only. Project editor preview and export keep catalog/randomized
 *  fillers. */
export const TEMPLATE_FILLER_PREVIEW_URL = '/videos/template-filler-preview-v1.mp4';

function layoutNeedsPreviewFiller(layout: PostLayoutConfig): boolean {
  if (layout.kind === 'satisfatorio' || layout.kind === 'triple_split') return true;
  if (layout.kind !== 'fofoca') return false;
  return !(layout.imageUrl && resolveFofocaStoryMedia(layout) === 'image');
}

/** Swap catalog/randomized fillers for the compiled local reel. Does not
 *  mutate stored kit data. Empty required-media layouts also get the reel so
 *  carousel cards never render a blank filler slot. */
export function applyTemplatePreviewFillers<T extends PostLayoutConfig>(
  layout: T | null,
  options?: { fillerUrl?: string },
): T | null {
  if (!layout || !layoutNeedsPreviewFiller(layout)) return layout;
  const fillerUrl = options?.fillerUrl ?? TEMPLATE_FILLER_PREVIEW_URL;
  const reel = [fillerUrl];
  const next: T = {
    ...layout,
    fillerRandomize: false,
    fillerUrl,
    fillerUrls: reel,
  };

  if (layout.kind === 'triple_split') {
    return {
      ...next,
      bottomFillerRandomize: false,
      bottomFillerUrl: fillerUrl,
      bottomFillerUrls: reel,
    };
  }

  if (layout.kind === 'fofoca') {
    return { ...next, storyMedia: 'video' };
  }

  return next;
}
